// extracted by css-extract-rspack-plugin
export default {"employerIdContainer":"employer-id-container--RsA5CRDc45IsdfAU","employerNumberContainer":"employer-number-container--eLjVIAzEBMEoPW6U"};